module.exports = __webpack_public_path__ + "fonts/Graphik-MediumItalic.cf06a31e.woff";